// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d1f71e0","453":"38f4e450","455":"0705df97","977":"ec04204e"}[chunkId] + ".chunk.js";
};